import React from "react";
import "../../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy } from "lodash";
import Modal from "../../../components/Modal/Modal.jsx";
import { db } from "../../../services/firebase";
import ProductForm from "../../../forms/ProductForm.jsx";
import { resetForm } from "../../../ducks/Forms";
import SweetAlert from "react-bootstrap-sweetalert";
import Gallery from "../../../components/Gallery/Gallery.jsx";
import NotificationSystem from "react-notification-system";
import Button from "../../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import SweetSpinner from "../../../components/SweetSpinner/SweetSpinner.jsx";
import { style as NotifyStyle } from "../../../variables/Variables.jsx";
import { faPencilAlt, faTrash } from "@fortawesome/fontawesome-free-solid";

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      fetchingProducts: true,
      productModal: false,
      imageModal: false,
      targetProduct: null,
      products: {},
      alert: null,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this._fetchProducts();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div>
        {this.state.alert}
        {this.productModal()}
        {this.imageModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="default"
              wd
              className="pull-right"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.props.resetForm("ProductForm");
                this.setState({ productModal: true, targetProduct: null });
              }}
            >
              Adicionar Produto
            </Button>
          </Col>
        </Row>
        {this._renderProductsTable(this.state.products)}
      </div>
    );
  }

  _fetchProducts = () => {
    const { companyID } = this.props;
    this.setState({ fetchingProducts: true });
    db.collection("companies")
      .doc(companyID)
      .collection("products")
      .onSnapshot((productSnapshot) => {
        if (!productSnapshot.empty) {
          const products = [];
          productSnapshot.forEach((product) =>
            products.push({ ...product.data(), id: product.id })
          );
          this.setState({ fetchingProducts: false, products });
        } else {
          this.setState({ fetchingProducts: false });
        }
      });
  };

  _setProduct = (values) => {
    this.setState({ productModal: false });
    this.waitAlert("Salvando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("products")
      .add({ name: values.name, lines: values.lines })
      .then(() => {
        this.hideAlert();
        this.notify("Produto adicionado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar produto", "error");
      });
  };

  _updateProduct = (productID) => (values) => {
    this.setState({ productModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("products")
      .doc(productID)
      .update({ name: values.name, lines: values.lines })
      .then(() => {
        this.hideAlert();
        this.notify("Produto atualizado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao atualizar produto", "error");
      });
  };

  _remove = (id) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);

    const PromiseStack = [];
    const { companyID } = this.props;

    db.collection("companies")
      .doc(companyID)
      .collection("results")
      .where("product", "==", id)
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.hideAlert();
          this.waitAlert("Removendo, aguarde", false);
          db.collection("companies")
            .doc(companyID)
            .collection("products")
            .doc(id)
            .delete()
            .then(() => {
              db.collection("companies")
                .doc(companyID)
                .collection("indicators")
                .where("product", "==", id)
                .get()
                .then((indicators) => {
                  if (!indicators.empty) {
                    indicators.forEach((i) => {
                      PromiseStack.push(
                        db
                          .collection("companies")
                          .doc(companyID)
                          .collection("indicators")
                          .doc(i.id)
                          .delete()
                      );
                    });

                    Promise.all(PromiseStack)
                      .then(() => {
                        this.hideAlert();
                        this.notify(
                          "O produto e seus indicadores foram removidos",
                          "success"
                        );
                      })
                      .catch((e) => {
                        this.hideAlert();
                        this.notify(
                          "Erro ao remover os indicadores relacionados ao produto",
                          "error"
                        );
                      });
                  } else {
                    this.hideAlert();
                    this.notify("Produto removido", "success");
                  }
                });
            })
            .catch((e) => {
              this.hideAlert();
              this.notify("Erro ao remover produto", "error");
            });
        } else {
          this.hideAlert();
          this.notify(
            "Este produto possui ligações com os dados da empresa e não pode ser removido.",
            "warning"
          );
        }
      });
  };

  productModal = () => {
    const { targetProduct } = this.state;
    return (
      <Modal
        title={targetProduct ? "Atualizar produto" : "Adicionar produto"}
        isOpen={this.state.productModal}
        content={
          <ProductForm
            initialValues={targetProduct}
            companyID={this.props.companyID}
            onSubmit={(values) => {
              targetProduct
                ? this._updateProduct(targetProduct.id)(values)
                : this._setProduct(values);
            }}
            handleCancel={() =>
              this.setState({ productModal: false, targetProduct: null })
            }
          />
        }
      />
    );
  };

  imageModal = () => {
    return (
      <Modal
        size="modal__uncontrolled"
        isOpen={this.state.imageModal}
        content={
          <Gallery
            handleClose={() =>
              this.setState({ imageModal: false, targetProduct: null })
            }
            companyID={this.props.companyID}
            targetProduct={this.state.targetProduct}
            notify={this.notify}
          />
        }
      />
    );
  };

  _renderProductsTable = (data) => (
    <ReactTable
      columns={[
        { Header: "Nome", accessor: "name" },
        {
          Header: "Ações",
          accessor: "",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({ targetProduct: value, productModal: true })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faPencilAlt} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-danger btn-icon"
                  onClick={() => this.removeAlert(value.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </OverlayTrigger>
            </div>
          ),
        },
      ]}
      data={orderBy(toArray(data), ["name", "asc"])}
      onFetchData={this._fetchProducts}
      loading={this.state.fetchingProducts}
      defaultPageSize={10}
      className="-striped -highlight"
      previousText="Anterior"
      nextText="Próximo"
      loadingText="Carregando"
      noDataText="Nenhum produto encontrado"
      pageText="Página"
      ofText="de"
      rowsText="Registros"
    />
  );

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeAlert = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Os indicadores deste produto também serão removidos.
        </SweetAlert>
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

export default connect(null, { resetForm })(Products);



// WEBPACK FOOTER //
// ./src/views/Companies/Tabs/Products.jsx